import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#343b3f",
        d: "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-4.962-3.787a.937.937 0 0 0-1.35.027l-4.342 5.531L6.73 9.154a.938.938 0 0 0-1.325 1.325l3.308 3.309a.94.94 0 0 0 1.348-.026l4.99-6.237a.94.94 0 0 0-.012-1.312z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }